var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"nav"},[_c('li',{staticClass:"nav-item header"},[_vm._v("Team")]),_vm._l((_vm.filteredCounsellorList),function(item,idx){return _c('li',{key:idx,staticClass:"nav-item"},[_vm._t("default",function(){return [_c('span',{class:[
          'status', {
          'green': item.status === 'Available',
          'orange': item.status === 'Away'}]}),_vm._v(" "+_vm._s(item.name)+" "+_vm._s(item.name === _vm.counsellor.name ? ' (you)' : '')+" ")]},{"row":item})],2)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }